import { render, staticRenderFns } from "./PurchaseHistory.vue?vue&type=template&id=b994d8d8&scoped=true&"
import script from "./PurchaseHistory.vue?vue&type=script&lang=ts&"
export * from "./PurchaseHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseHistory.vue?vue&type=style&index=0&id=b994d8d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b994d8d8",
  null
  
)

export default component.exports